export const downloadOptions = ['GLB', 'STL', 'OBJ', 'JSON'];

export const buttons: any = {
  center: [
    {
      id: 'pricing',
      title: 'Pricing',
      action: { type: 'EDITOR', verb: 'toPricing' },
      flavour: 'free',
    },
    {
      id: 'save',
      title: 'Save Model',
      action: { type: 'PLAYGROUND', verb: 'saveToProject' },
      flavour: 'playground',
    },
    {
      id: 'share',
      title: 'Share',
      action: { type: 'MODELS', verb: 'share' },
      flavour: 'hidden',
    },
  ],

  right: [
    {
      id: 'copy',
      iconName: 'IconCopy',
      action: { type: 'EDITOR', verb: 'copy' },
    },
    {
      id: 'movie',
      iconName: 'IconMovie',
      action: { type: 'SCREENSHOTS', verb: 'allGeneratorsVideo' },
      flavour: 'sloyd-only',
    },

    {
      id: 'recipe',
      iconName: 'IconCamera',
      action: { type: 'EDITOR', verb: 'recipe' },
    },
    {
      id: 'qr',
      iconName: 'IconQrcode',
      action: { type: 'EDITOR', verb: 'qrCode' },
      flavour: 'sloyd-only',
    },
    {
      id: 'embed',
      iconName: 'IconCode',
      action: { type: 'EDITOR', verb: 'embed' },
      flavour: 'sloyd-only',
    },
    {
      id: 'guidance',
      iconName: 'IconHelpHexagon',
      action: { type: 'GUIDANCE', verb: 'show' },
    },
  ],
};

/*
{!isPayingUser && (
        <Button variant='subtle' onClick={() => callbacks.onNavigate('/pricing')}>
          Pricing
        </Button>
      )}
      {isPlayground ? (
        <Button
          color='pink'
          variant='subtle'
          size='xs'
          onClick={() => callbacks.onAction({ type: 'PLAYGROUND', verb: 'saveToProject' })}
        >
          Save Model
        </Button>
      ) : (
        <Button
          color='pink'
          variant='subtle'
          size='xs'
          onClick={() => callbacks.onAction({ type: 'MODELS', verb: 'share' })}
        >
          Share
        </Button>




         <ActionIcon
            onClick={() => callbacks.onAction({ type: 'EDITOR', verb: 'copy' })}
            variant='light'
            color='pink'
            aria-label='copy'
          >
            <icons.IconCopy style={{ width: '70%', height: '70%' }} stroke={1.5} />
          </ActionIcon>

          {isEmployee && (
            <ActionIcon
              onClick={() =>
                callbacks.onAction({
                  type: 'SCREENSHOTS',
                  verb: 'allGeneratorsVideo',
                })
              }
              variant='light'
              color='pink'
              aria-label='screenshots'
            >
              <icons.IconMovie style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          )}
          <ActionIcon
            onClick={() => callbacks.onAction({ type: 'GUIDANCE', verb: 'show' })}
            variant='light'
            color='pink'
            aria-label='guidance'
          >
            <icons.IconHelpHexagon style={{ width: '70%', height: '70%' }} stroke={1.5} />
          </ActionIcon>
          <ActionIcon
            onClick={() => callbacks.onAction({ type: 'EDITOR', verb: 'recipe' })}
            variant='light'
            color='pink'
            aria-label='screenshot'
          >
            <icons.IconCamera style={{ width: '70%', height: '70%' }} stroke={1.5} />
          </ActionIcon>

*/
